import React, { useEffect, useState } from 'react';
import { searchRatedVenues, venueDisplayName, type GrowthVenue } from '../lib/growth';

/** Compact search-and-pick control for rated venues (Mockups + Content Studio). */
export function VenuePicker({
  current,
  onPick,
}: {
  current: GrowthVenue | null;
  onPick: (v: GrowthVenue) => void;
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<GrowthVenue[]>([]);

  useEffect(() => {
    if (!open) return;
    const t = window.setTimeout(() => {
      void searchRatedVenues(query).then(setResults);
    }, 250);
    return () => window.clearTimeout(t);
  }, [query, open]);

  return (
    <div className="relative">
      <div className="flex items-center gap-2 text-[12px] text-mutedDim">
        Venue
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="admin-btn admin-btn-secondary admin-btn-sm"
        >
          {current ? venueDisplayName(current) : 'Pick a venue'} ▾
        </button>
      </div>
      {open ? (
        <div className="absolute left-0 top-full z-30 mt-2 w-[320px] rounded-lg border border-borderStrong bg-surfaceElevated p-2 shadow-2xl">
          <input
            autoFocus
            className="admin-input mb-2 !text-[12px]"
            placeholder="Search rated venues…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className="max-h-[260px] overflow-y-auto">
            {results.length === 0 ? (
              <div className="px-2 py-3 text-[12px] text-mutedDim">No rated venues match.</div>
            ) : (
              results.map((v) => (
                <button
                  key={v.id}
                  type="button"
                  onClick={() => {
                    setOpen(false);
                    setQuery('');
                    onPick(v);
                  }}
                  className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-[12.5px] text-textPrimary hover:bg-white/[0.05]"
                >
                  <span className="min-w-0 flex-1 truncate">{venueDisplayName(v)}</span>
                  <span className="shrink-0 text-[11px] tabular-nums text-mutedDim">
                    {v.venue_shado_unique_users ?? 0} raters
                  </span>
                </button>
              ))
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
}
